import dayjs from "dayjs"
import { formatDate } from "~/utils/formatDate"

const today = dayjs(new Date())
export const getResultsDate = (weeks: number): string => {
  const date = today.add(weeks, "weeks").toDate()
  return formatDate("SHORT_MONTH_DAY")(date)
}
